import Header from '@/components/Header.vue'
import NotFound from '@/components/utils/NotFound.vue'
import NotAllowed from '@/components/utils/NotAllowed.vue'

export default [
    {
        path: '*',
        name: '404',
        components: {
            header: Header,
            content: NotFound
        }
    },
    {
        path: '/unauthorized',
        name: '401',
        components: {
            header: Header,
            content: NotAllowed
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/service/index.js